import type { WorkflowAutomaticSourcePayload } from '@Application/Organizations/Workflows/Actions/organizationWorkflowsFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * A document type reused as input of a preparation; `verifiedOnly` restricts it to verified documents.
 */
class WorkflowAutomaticSourceView {
	readonly documentTypeId: number;
	readonly verifiedOnly: boolean;

	constructor(payload: WorkflowAutomaticSourcePayload) {
		this.documentTypeId = payload.documentType.id;
		this.verifiedOnly = payload.verifiedOnly;

		Object.freeze(this);
	}
}

export default WorkflowAutomaticSourceView;
